import { Skeleton } from "@foreday/ui/components/skeleton";
import { cn } from "@foreday/ui/lib/utils";

// Widths follow the loading frame; they only suggest text, so none is a token.
function Lines({ widths }: { readonly widths: readonly string[] }) {
  return (
    <div className="flex flex-col gap-3">
      {widths.map((width) => (
        <Skeleton key={width} className="h-2.5" style={{ width }} />
      ))}
    </div>
  );
}

function Rows({ widths }: { readonly widths: readonly string[] }) {
  return (
    <div className="flex flex-col gap-4">
      {widths.map((width) => (
        <div key={width} className="flex items-center gap-3">
          <Skeleton className="size-[var(--icon-size)] shrink-0" />
          <Skeleton className="h-2.5" style={{ width }} />
        </div>
      ))}
    </div>
  );
}

const heading = <Skeleton className="h-3 w-12" />;

/** The comments while they load: two authors, the second with a longer comment. */
export function CommentsSkeleton() {
  return (
    <div aria-hidden="true" className="flex flex-col gap-4">
      <div className="flex items-center gap-3">
        <Skeleton className="size-[var(--icon-size)] shrink-0" />
        <Skeleton className="h-2.5 w-55" />
      </div>
      <div className="flex gap-3">
        <Skeleton className="size-[var(--icon-size)] shrink-0" />
        <Skeleton className="h-15 flex-1 rounded-group" />
      </div>
    </div>
  );
}

/** The notes while the task's own read is on its way. */
export function NotesSkeleton() {
  return (
    <div aria-hidden="true" className="flex flex-col gap-4">
      {heading}
      <Lines widths={["100%", "92%", "58%"]} />
    </div>
  );
}

/**
 * The whole panel before the tasks or its code have arrived (loading frame 02). Its top space
 * stands in for the task panel's header; a panel that draws its own header passes less.
 */
export function TaskPanelSkeleton({
  className,
}: {
  readonly className?: string;
}) {
  return (
    <div
      aria-hidden="true"
      className={cn("flex flex-col gap-4 px-5 pt-16", className)}
    >
      <NotesSkeleton />
      <hr className="my-2 border-border" />
      {heading}
      <Rows widths={["45%", "38%", "41%"]} />
      <hr className="my-2 border-border" />
      {heading}
      <CommentsSkeleton />
    </div>
  );
}
